<div class="menu" (click)="menuClicked($event)">
    <div class="main-menu">
        <perfect-scrollbar class="scroll" [config]="{suppressScrollX: true}">
            <ul class="list-unstyled">
              <ng-container *ngFor="let item of menuItems">
<!--                <ng-container *ngIf="((item.id) == 'card-list' || (item.id) == 'Payments'|| (item.id) == 'setting')">-->
                <li [hidden]="!item.isVisible"
                    [ngClass]="{'active': (selectedParentMenu === item.id && viewingParentMenu === '') || viewingParentMenu === item.id}">
                    <a *ngIf="item.newWindow" [href]="item.to" rel="noopener noreferrer" target="_blank">
                      <img style="width: 40px;" src="assets/img/menu/{{ item.icon }}"/>
<!--                        <i [ngClass]="item.icon"></i>-->
                      {{item.label | translate}}</a>
                    <a *ngIf="!item.newWindow && item.subs &&  item.subs.length>0"
                        (click)="openSubMenu($event,item); false" [href]="item.to">
<!--                        <i [ngClass]="item.icon"></i> -->
                      <img style="width: 40px;" src="assets/img/menu/{{ item.icon }}"/>
                      {{item.label | translate}}</a>
                    <a *ngIf="!item.newWindow && (!item.subs || (item.subs &&  item.subs.length===0))"
                        (click)="changeSelectedParentHasNoSubmenu(item.id); false" [routerLink]="item.to">
<!--                        <i [ngClass]="item.icon"></i>-->
                      <img style="width: 40px;" src="assets/img/menu/{{ item.icon }}"/>
                      {{item.label | translate}}</a>
                </li>
<!--                </ng-container>-->
<!--                <ng-container *ngIf="((item.id) != 'card-list' && (item.id) != 'Payments'&& (item.id) != 'setting')">-->
<!--                  <li-->
<!--                      [ngClass]="{'active': (selectedParentMenu === item.id && viewingParentMenu === '') || viewingParentMenu === item.id}">-->
<!--                    <a *ngIf="item.newWindow" [href]="item.to" rel="noopener noreferrer" target="_blank">-->
<!--                      <img style="width: 40px;" src="assets/img/menu/{{ item.icon }}"/>-->
<!--                      &lt;!&ndash;                        <i [ngClass]="item.icon"></i>&ndash;&gt;-->
<!--                      {{item.label | translate}} gg</a>-->
<!--                    <a *ngIf="!item.newWindow && item.subs &&  item.subs.length>0"-->
<!--                       (click)="openSubMenu($event,item); false" [href]="item.to">-->
<!--                      &lt;!&ndash;                        <i [ngClass]="item.icon"></i> &ndash;&gt;-->
<!--                      <img style="width: 40px;" src="assets/img/menu/{{ item.icon }}"/>-->
<!--                      {{item.label | translate}} gg</a>-->
<!--                    <a *ngIf="!item.newWindow && (!item.subs || (item.subs &&  item.subs.length===0))"-->
<!--                       (click)="changeSelectedParentHasNoSubmenu(item.id); false" [routerLink]="item.to">-->
<!--                      &lt;!&ndash;                        <i [ngClass]="item.icon"></i>&ndash;&gt;-->
<!--                      <img style="width: 40px;" src="assets/img/menu/{{ item.icon }}"/>-->
<!--                      {{item.label | translate}} gg</a>-->
<!--                  </li>-->
<!--                </ng-container>-->
              </ng-container>
            </ul>
        </perfect-scrollbar>
    </div>
    <div class="sub-menu">
        <perfect-scrollbar class="scroll" [config]="{suppressScrollX: true}">
            <ul class="list-unstyled" *ngFor="let item of menuItems" [attr.data-parent]="item.id"
                [ngClass]="{'d-block': (selectedParentMenu === item.id && viewingParentMenu==='') || viewingParentMenu === item.id}">
                <li *ngFor="let sub of item.subs"
                    [ngClass]="{'active': currentUrl === sub.to ,'has-sub-item' : sub.subs&& sub.subs.length>0 }">
                    <a *ngIf="sub.newWindow" [href]="sub.to" rel="noopener noreferrer" target="_blank">
<!--                        <i [ngClass]="sub.icon"></i>-->
<!--                      <img style="width: 40px;margin-right: 2px;" src="assets/img/menu/{{ sub.icon }}"/>-->
                        <span class="d-inline-block">{{sub.label | translate}}</span>
                    </a>
                    <a *ngIf="!sub.newWindow && (!sub.subs || sub.subs.length<=0)" [routerLink]="[sub.to]"
                        routerLinkActive="active">
<!--                        <i [ngClass]="sub.icon"></i>-->
<!--                      <img style="width: 40px; margin-right: 2px;" src="assets/img/menu/{{ sub.icon }}"/>-->
                        <span class="d-inline-block">{{sub.label | translate}}</span>
                    </a>
                    <a (click)="collapseSub.toggle()" *ngIf="sub.subs && sub.subs.length > 0"
                        class="rotate-arrow-icon opacity-50 c-pointer">
                        <i class="simple-icon-arrow-down"></i>
                        <span class="d-inline-block">{{sub.label | translate}}</span>
                    </a>
                    <div [collapse]="false" #collapseSub="bs-collapse" [isAnimated]="true">
                        <div *ngIf="sub.subs && sub.subs.length > 0">
                            <ul class="list-unstyled inner-level-menu">
                                <li *ngFor="let deepSub of sub.subs" [ngClass]="{'active': currentUrl === deepSub.to}">
                                    <a *ngIf="deepSub.newWindow" [href]="deepSub.to" rel="noopener noreferrer"
                                        target="_blank">
<!--                                        <i [ngClass]="deepSub.icon"></i>-->
<!--                                      <img style="width: 40px;margin-right: 2px;" src="assets/img/menu/{{ deepSub.icon }}"/>-->
                                        <span class="d-inline-block">{{deepSub.label | translate}}</span>
                                    </a>
                                    <a *ngIf="!deepSub.newWindow && (!deepSub.subs || deepSub.subs.length<=0)"
                                        [routerLink]="[deepSub.to]" routerLinkActive="active">
<!--                                      <img style="width: 40px;margin-right: 2px;" src="assets/img/menu/{{ deepSub.icon }}"/>-->
                                        <span class="d-inline-block">{{deepSub.label | translate}}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
            </ul>
        </perfect-scrollbar>
    </div>
</div>
